import { render, staticRenderFns } from "./TaskRow.vue?vue&type=template&id=59715dd0&"
import script from "./TaskRow.vue?vue&type=script&lang=ts&"
export * from "./TaskRow.vue?vue&type=script&lang=ts&"
import style0 from "./TaskRow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports